import React from 'react';
import { Card } from 'react-bootstrap';
import { PdfLoader } from './PdfLoader';
import { Pie } from 'react-chartjs-2';
import { useSelector } from 'react-redux';

interface Props {
  data: any;
}

export const CapitalProgressByOwner = (props: Props) => {
  const { user } = useSelector((state: any) => ({ user: state.user }));

  return props.data.physicalOwnerView
    .filter((owner) => owner.source === user.currentRole.source)
    .map((owner, index) => (
      <Card style={{ width: '100%' }} className='mr-2 mb-2' key={index}>
        <Card.Header style={{ backgroundColor: '#eef' }}>
          Capital Physical Owner #{owner.PhysicalOwner} <span className='float-right'>{user.currentRole.isAdmin && <PdfLoader owner={owner} />}</span>
          <Card.Subtitle className='mt-2'>Property Coordinator: {owner.PropertyCoordinator}</Card.Subtitle>
        </Card.Header>
        <Card.Body>
          <Card.Subtitle className='text-muted'>
            Capital Total Items: {owner.TotalItems}
            <span className='float-right'>{Number.parseFloat(owner.PercentComplete || 0).toFixed(0)}% Complete</span>
          </Card.Subtitle>
          <Pie
            data={{
              labels: ['Unscanned Items', 'Scanned Items'],
              datasets: [
                {
                  label: 'Scanned',
                  data: [owner.TotalItems - owner.ItemsVerified, owner.ItemsVerified],
                  backgroundColor: ['#F39C12', '#00bc8c'],
                },
              ],
            }}
            options={{
              maintainAspectRatio: true,
              responsive: true,
              legend: { display: false },
            }}
          />
        </Card.Body>
      </Card>
    ));
};
